export const categories = [
  {
    id: "cat-1",
    name: "明星八卦",
    slug: "celebrity-gossip",
    description: "最新明星恋情、分手、出轨、隐婚等独家爆料，第一手娱乐资讯不容错过",
    icon: "ri-star-smile-line",
    articleCount: 1286,
    image: "https://readdy.ai/api/search-image?query=Chinese%20celebrity%20red%20carpet%20event%20with%20warm%20spotlight%20photography%2C%20paparazzi%20style%20high%20contrast%20glamorous%20atmosphere%2C%20dark%20background%20with%20golden%20warm%20tones%2C%20editorial%20fashion%20photography&width=800&height=600&seq=cat-celebrity-01&orientation=landscape",
  },
  {
    id: "cat-2",
    name: "网红爆料",
    slug: "influencer-gossip",
    description: "网络红人翻车现场、黑历史曝光、带货翻车、 fake 人设崩塌实锤",
    icon: "ri-live-line",
    articleCount: 945,
    image: "https://readdy.ai/api/search-image?query=Social%20media%20influencer%20livestream%20setup%20with%20ring%20light%20warm%20ambient%20lighting%2C%20behind%20the%20scenes%20photography%20style%2C%20dark%20moody%20atmosphere%20with%20orange%20warm%20glow%2C%20editorial%20documentary%20style&width=800&height=600&seq=cat-influencer-01&orientation=landscape",
  },
  {
    id: "cat-3",
    name: "综艺热点",
    slug: "variety-shows",
    description: "热门综艺节目内幕、嘉宾冲突、剪辑黑幕、收视率造假独家揭秘",
    icon: "ri-tv-line",
    articleCount: 723,
    image: "https://readdy.ai/api/search-image?query=Television%20studio%20recording%20set%20with%20warm%20stage%20lighting%20and%20audience%20seats%2C%20behind%20the%20scenes%20documentary%20photography%2C%20dramatic%20warm%20spotlight%20on%20empty%20stage%2C%20dark%20cinematic%20atmosphere&width=800&height=600&seq=cat-variety-01&orientation=landscape",
  },
  {
    id: "cat-4",
    name: "影视资讯",
    slug: "film-tv-news",
    description: "影视剧选角内幕、片酬曝光、剧组矛盾、票房造假、抄袭争议深度报道",
    icon: "ri-movie-2-line",
    articleCount: 612,
    image: "https://readdy.ai/api/search-image?query=Movie%20theater%20interior%20with%20projector%20beam%20warm%20golden%20light%2C%20empty%20cinema%20seats%20dramatic%20lighting%2C%20cinematic%20atmosphere%20with%20warm%20amber%20tones%20against%20dark%20background%2C%20editorial%20photography&width=800&height=600&seq=cat-film-01&orientation=landscape",
  },
  {
    id: "cat-5",
    name: "社会热点",
    slug: "social-hot",
    description: "社会新闻热点事件追踪、民生话题讨论、网络热议事件深度分析与解读",
    icon: "ri-fire-line",
    articleCount: 534,
    image: "https://readdy.ai/api/search-image?query=Urban%20city%20night%20street%20scene%20with%20neon%20signs%20warm%20lights%20crowd%20movement%20blur%2C%20documentary%20street%20photography%20style%2C%20moody%20atmospheric%20warm%20tones%20against%20dark%20night%20sky%2C%20cinematic%20composition&width=800&height=600&seq=cat-social-01&orientation=landscape",
  },
  {
    id: "cat-6",
    name: "财经秘闻",
    slug: "finance-gossip",
    description: "商界大佬花边新闻、企业内幕、资本博弈、股市黑幕独家追踪报道",
    icon: "ri-money-cny-circle-line",
    articleCount: 421,
    image: "https://readdy.ai/api/search-image?query=Luxury%20business%20meeting%20room%20with%20warm%20wooden%20table%20and%20soft%20ambient%20lighting%2C%20executive%20office%20interior%20photography%2C%20dramatic%20warm%20golden%20tones%20with%20dark%20shadows%2C%20editorial%20corporate%20style&width=800&height=600&seq=cat-finance-01&orientation=landscape",
  },
];